import { render, staticRenderFns } from "./batchInvalidImport.vue?vue&type=template&id=06ae170f&scoped=true&"
import script from "./batchInvalidImport.vue?vue&type=script&lang=js&"
export * from "./batchInvalidImport.vue?vue&type=script&lang=js&"
import style0 from "./batchInvalidImport.vue?vue&type=style&index=0&id=06ae170f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae170f",
  null
  
)

export default component.exports